import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=456b9e9c&scoped=true"
import script from "./BaseData.vue?vue&type=script&lang=js"
export * from "./BaseData.vue?vue&type=script&lang=js"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=456b9e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b9e9c",
  null
  
)

export default component.exports